import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CrossIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="32" height="32" viewBox="0 0 32 32" {...props}>
    <circle id="Ellipse_3113" data-name="Ellipse 3113" cx="16" cy="16" r="16" fill="#c60a12" />
    <g id="cross-2" data-name="cross" transform="translate(10 10)">
      <line
        id="Line_114"
        data-name="Line 114"
        x2="16.97"
        transform="translate(0 0) rotate(45)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <line
        id="Line_115"
        data-name="Line 115"
        x2="16.97"
        transform="translate(12 0) rotate(135)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <line
        id="Line_114-2"
        data-name="Line 114"
        x2="16.97"
        transform="translate(0 0) rotate(45)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <line
        id="Line_115-2"
        data-name="Line 115"
        x2="16.97"
        transform="translate(12 0) rotate(135)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </g>
  </Svg>
));

CrossIcon.displayName = 'CrossIcon';

export default CrossIcon;
